import moment from 'moment';

const dateFormat = 'DD/MM/YYYY';
const dateFormatWithTime = 'DD/MM/YYYY h:mm A';
export const transformDate = (date: Date, withTime?: boolean) =>
	moment(date).format(withTime ? dateFormatWithTime : dateFormat);
